// === HoveredFieldMenu.jsx  (May-01 – final bubble-guard fix) ================
import React from 'react';
import IconButton from '@mui/material/IconButton';
import Tooltip    from '@mui/material/Tooltip';
import EditIcon   from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { useFormLayout } from '../../../contexts/FormLayoutContext';
import { useFieldEdit   } from '../../../contexts/FieldEditContext';

const HoveredFieldMenu = ({ fieldId, onDelete }) => {
  /* ─────────────── context hooks ─────────────── */
  const { selectField: selectFromLayout } = useFormLayout();
  const { selectFieldForEdit            } = useFieldEdit();

  if (!fieldId) {
    console.warn('[HoveredFieldMenu] Invalid fieldId – rendering skipped.');
    return null;
  }

  /* ─────────────── handlers ─────────────── */
  const handleEdit = async () => {
    console.log('[HoveredFieldMenu] Edit clicked →', fieldId);
    selectFromLayout(fieldId);
    await selectFieldForEdit(fieldId);
  };

  /** Stop the event after it has reached the menu container so it can
   *  NOT bubble further up to DraggableItem / React-DnD. We do this for
   *  **mouse-down / click / mouse-up** to cover every phase that might
   *  initiate a drag. */
  const stopAtMenu = (e) => e.stopPropagation();

  /* ─────────────── render ─────────────── */
  return (
    <div
      data-hovered-menu          /* ← HoveredField’s hit-test */
      onMouseDown={stopAtMenu}   /* bubble-phase guard        */
      onMouseUp={stopAtMenu}
      onClick={stopAtMenu}
      style={{
        position : 'absolute',
        top      : '-20px',
        right    :  '5px',
        zIndex   :  9999,
        overflow : 'visible',
      }}
    >
      <div
        style={{
          backgroundColor : '#3F7FBF',
          padding         : '3px 5px',
          borderRadius    : 3,
          display         : 'flex',
          alignItems      : 'center',
        }}
      >
        {/* Edit --------------------------------------------------------- */}
        <Tooltip title="Edit">
          <div style={{ display:'flex', alignItems:'center',
                        justifyContent:'center', width:24, height:24,
                        marginRight:5 }}>
            <IconButton onClick={handleEdit} size="small">
              <EditIcon  style={{ color:'#FFF', fontSize:16 }} />
            </IconButton>
          </div>
        </Tooltip>

        {/* Delete ------------------------------------------------------- */}
        <Tooltip title="Delete">
          <div style={{ display:'flex', alignItems:'center',
                        justifyContent:'center', width:24, height:24 }}>
            <IconButton onClick={onDelete} size="small">
              <DeleteIcon style={{ color:'#FFF', fontSize:16 }} />
            </IconButton>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default HoveredFieldMenu;
